/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type ModulesConfigAuditListScope = typeof ModulesConfigAuditListScope[keyof typeof ModulesConfigAuditListScope];


export const ModulesConfigAuditListScope = {
  class: 'class',
  global: 'global',
  school: 'school',
  student: 'student',
  user: 'user',
} as const;
